import { render } from "./DefaultLayout.vue?vue&type=template&id=20d123f1"
import script from "./DefaultLayout.vue?vue&type=script&lang=js"
export * from "./DefaultLayout.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\lawrenj\\source\\repos\\Bitbucket_Cloud\\tgi_friends_of_gideons_vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__